module.exports = __webpack_public_path__ + "img/ic_zoom.a78ff5a3.svg";